import { render, staticRenderFns } from "./SidebarHeader.vue?vue&type=template&id=7d09c884"
import script from "./SidebarHeader.vue?vue&type=script&lang=js"
export * from "./SidebarHeader.vue?vue&type=script&lang=js"
import style0 from "./SidebarHeader.vue?vue&type=style&index=0&id=7d09c884&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports